import React from 'react';
import styled, { css } from 'styled-components';
import starsImage from '../../assets/stars.jpg'; // Adjust the path as necessary

const waveEffect = css`
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20px; /* Height of the wave effect */
  background: repeating-linear-gradient(
    -45deg,
    transparent,
    transparent 10px,
    rgba(255, 255, 255, 0.2) 10px,
    rgba(255, 255, 255, 0.2) 20px
  );
`;

const StyledDivider = styled.div`
  position: relative;
  height: 200px; /* Adjust the height as needed */
  background-image: url(${props => props.backgroundImage});
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* Ensures no overflow from the wave effect */
  color: #FFFFFF; /* Font color set to white */
  font-size: 32px; /* Default font size for larger screens */

  /* Responsive adjustments */
  @media (max-width: 768px) {
    font-size: 24px; /* Smaller font size for tablets and below */
  }

  @media (max-width: 480px) {
    font-size: 18px; /* Even smaller font size for mobile phones */
  }

  &::before,
  &::after {
    ${waveEffect}
    transform: rotate(180deg);
  }

  &::after {
    bottom: auto;
    top: 0;
    transform: rotate(0deg);
  }
`;

const Divider = ({ title }) => {
    return (
      <StyledDivider backgroundImage={starsImage}>
        {title}
      </StyledDivider>
    );
};

export default Divider;
